module.exports = __webpack_public_path__ + "static/media/right-arrow.caf9dbc3.svg";